import "./FormCheckbox.css";

interface PulseCheckboxProps {
  id: string;
  label: string;
  value: boolean;
  onChange: (checked: boolean) => void;
}

const FormCheckbox: React.FC<PulseCheckboxProps> = ({
  id,
  label,
  value,
  onChange,
}) => {
  return (
    <label htmlFor={id} className="pulse-checkbox-container">
      {label}
      <input
        id={id}
        type="checkbox"
        checked={value}
        onChange={(e) => onChange(e.target.checked)}
        className="pulse-checkbox-input"
      />
      <span className="pulse-checkbox-custom" />
    </label>
  );
};

export default FormCheckbox;
